"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("./context");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2022 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var Item = /*#__PURE__*/_react.default.forwardRef(function Item(_ref, ref) {
  var children = _ref.children,
      _ref$divider = _ref.divider,
      divider = _ref$divider === void 0 ? false : _ref$divider,
      _ref$expand = _ref.expand,
      expand = _ref$expand === void 0 ? false : _ref$expand,
      index = _ref.index,
      keyValue = _ref.keyValue,
      style = _ref.style;

  var _useContext = (0, _react.useContext)(_context.VerticalBarContext),
      activePanel = _useContext.activePanel,
      id = _useContext.id,
      onActivePanel = _useContext.onActivePanel;

  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)('tbar-item', {
      'tbar-divider-after': divider,
      'tbar-item-expand': expand
    }),
    ref: ref,
    role: "none",
    style: style
  }, /*#__PURE__*/_react.default.cloneElement(children, {
    'aria-controls': "".concat(id, "-tabpanel-").concat(keyValue),
    'aria-selected': activePanel === keyValue,
    className: (0, _classnames.default)('tbar-btn tbar-btn-monospaced', {
      active: activePanel === keyValue
    }),
    id: "".concat(id, "-tab-").concat(keyValue),
    onClick: function onClick(event) {
      if (children.props.onClick) {
        children.props.onClick(event);
      }

      if (event.defaultPrevented) {
        return;
      }

      onActivePanel(keyValue === activePanel ? null : keyValue);
    },
    role: 'tab',
    tabIndex: activePanel !== null && activePanel !== keyValue || activePanel === null && index !== 0 ? -1 : null
  }));
});

exports.Item = Item;